// extracted by mini-css-extract-plugin
module.exports = {"root":"Cell_root__1Us3o","first":"Cell_first__7rEWz","hidden":"Cell_hidden__11pxJ"};